import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  isLoggedIn: false,
  user: {},
  widthIsSmall: false,
  token: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;

      const roles = action.payload?.loginResponse?.body?.roles || [];
      const primaryRoleExist = roles.find((role) => role.type === "primary") || roles[0];

      localStorage.setItem("user_token", action.payload?.loginResponse?.body?.token);

      const mappedUser = {
        loc: Number(primaryRoleExist?.loc || 0),
        locationName: primaryRoleExist?.loc_name || "",
        role: primaryRoleExist?.role || "",
        roleList: roles,
        name: action.payload?.loginResponse?.body?.name || "",
        userId: action.payload?.loginResponse?.body?.user_id || "",
        loginName: action.payload?.inputName || "",
      };

      localStorage.setItem("user", JSON.stringify(mappedUser));
      state.user = mappedUser;
      state.token = localStorage.getItem("user_token") || "";
    },


    setSSOLogin(state, action) {
      const { token, user } = action.payload || {};
      if (!token) return;

      state.isLoggedIn = true;
      state.token = token;
      localStorage.setItem("user_token", token);

      // Token refresh responses are not guaranteed to include the complete user
      // object. Keep the already selected role/user data when it is omitted.
      const currentUser = state.user || {};
      const roles =
        user?.permissions?.roles ||
        user?.roles ||
        user?.roleList ||
        currentUser.roleList ||
        [];
      const primaryRole = roles.find((r) => r.type === "primary") || roles[0] || {};

      const mappedUser = {
        loc:
          primaryRole?.loc != null
            ? Number(primaryRole.loc)
            : user?.loc ?? currentUser.loc ?? null,
        locationName:
          primaryRole?.loc_name ||
          user?.locationName ||
          currentUser.locationName ||
          "",
        role: primaryRole?.role || user?.role || currentUser.role || "",
        roleList: roles,
        name: user?.display_name || user?.name || currentUser.name || "",
        userId: user?.user_id || user?.userId || currentUser.userId || "",
        loginName:
          user?.identifier || user?.loginName || currentUser.loginName || "",
      };

      state.user = mappedUser;
      localStorage.setItem("user", JSON.stringify(mappedUser));
    },

    changeRole(state, action) {
      state.isLoggedIn = true;
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.user = action.payload;
    },

    logout(state) {
      state.isLoggedIn = false;
      state.user = {};
      state.token = "";
      localStorage.clear();
    },

    checkauth(state) {
      const access_token = localStorage.getItem("user_token");
      state.token = access_token ? access_token : "";

      if (access_token) {
        state.isLoggedIn = true;
        const user = JSON.parse(localStorage.getItem("user"));
        state.user = user || {};
      } else {
        state.isLoggedIn = false;
        state.user = {};
      }
    },

    clearAuth(state) {
      state.isLoggedIn = false;
      state.user = {};
      state.token = "";
      localStorage.removeItem("user_token");
      localStorage.removeItem("user");
    },

    updateScreenWidth(state, action) {
      state.widthIsSmall = action.payload;
    },

    clearTokenData(state) {
      state.token = "";
      localStorage.removeItem("user_token");
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
